// Travel blog content. The composite image holds 2×2 destination panels;
// each card crops to its quadrant via background-position.

export const BLOG_HERO_IMG = "https://customer-assets.emergentagent.com/job_flight-booking-hub-21/artifacts/a3itnpw6_Travel%20Blog%20Images.png";
export const BLOG_HERO_EUROPE = "https://customer-assets.emergentagent.com/job_flight-booking-hub-21/artifacts/hkeyu4fx_travel%20blog%20images%20-%20europe.png";
export const BLOG_HERO_PACIFIC = "https://customer-assets.emergentagent.com/job_flight-booking-hub-21/artifacts/lpsxugoy_Travel%20Blog%20Images-%20Down%20Under.png";
export const BLOG_HERO_AMERICAS = "https://customer-assets.emergentagent.com/job_flight-booking-hub-21/artifacts/wu2m6gpb_Travel%20Blog%20Images-%20mexico.png";
export const BLOG_HERO_NORDIC = "https://customer-assets.emergentagent.com/job_flight-booking-hub-21/artifacts/4zd5z20m_Travel%20Blog%20Images-%20Nothern%20lights.png";
export const BLOG_HERO_UK = "https://customer-assets.emergentagent.com/job_flight-booking-hub-21/artifacts/u1g7aowi_Travel%20Blog%20Images-%20london.png";

export const BLOG_POSTS = {
  "asias-most-captivating-destinations": {
    slug: "asias-most-captivating-destinations",
    title: "Discover Asia's Most Captivating Destinations",
    subtitle: "Sri Lanka, Vietnam, Dubai & Thailand",
    excerpt:
      "Four destinations. Four very different ways to fall in love with travel — from Sri Lanka's ancient rock fortresses to Dubai's record-breaking skyline.",
    hero: BLOG_HERO_IMG,
    author: "TheCityPair Editorial",
    published_at: "December 2025",
    read_minutes: 9,
    destinations: [
      {
        anchor: "sri-lanka",
        name: "Sri Lanka",
        tagline: "The Pearl of the Indian Ocean",
        bg_position: "0% 0%", // top-left of the composite
      },
      {
        anchor: "vietnam",
        name: "Vietnam",
        tagline: "Culture & natural wonders",
        bg_position: "100% 0%", // top-right
      },
      {
        anchor: "dubai",
        name: "Dubai",
        tagline: "The ultimate luxury destination",
        bg_position: "0% 100%", // bottom-left
      },
      {
        anchor: "thailand",
        name: "Thailand",
        tagline: "The Land of Smiles",
        bg_position: "100% 100%", // bottom-right
      },
    ],
    sections: [
      {
        anchor: "sri-lanka",
        title: "Sri Lanka: The Pearl of the Indian Ocean",
        paragraphs: [
          "Nestled in the Indian Ocean, Sri Lanka is a destination that combines pristine beaches, ancient heritage, lush tea plantations, and incredible wildlife. Despite its compact size, the island offers a remarkable variety of experiences.",
          "Visitors can explore the ancient city of Sigiriya, a UNESCO World Heritage Site famous for its iconic rock fortress. Nature lovers can journey through the rolling tea estates of Nuwara Eliya, while wildlife enthusiasts can embark on safaris in Yala National Park to spot elephants, leopards, and exotic bird species.",
          "Sri Lanka's coastline is equally impressive, featuring golden beaches in Bentota, Mirissa, and Unawatuna. Whether you're surfing, whale watching, or simply enjoying the tropical scenery, Sri Lanka offers the perfect balance between relaxation and adventure.",
        ],
        highlights_title: "Top experiences in Sri Lanka",
        highlights: [
          "Climb the majestic Sigiriya Rock Fortress",
          "Visit the sacred Temple of the Tooth in Kandy",
          "Explore tea plantations in Nuwara Eliya",
          "Enjoy wildlife safaris in Yala National Park",
          "Relax on the beaches of Mirissa and Bentota",
        ],
      },
      {
        anchor: "vietnam",
        title: "Vietnam: A Journey Through Culture and Natural Wonders",
        paragraphs: [
          "Vietnam has emerged as one of Southeast Asia's most fascinating travel destinations. Rich in history, culture, and breathtaking landscapes, the country offers something for every type of traveler.",
          "The bustling streets of Hanoi showcase centuries-old traditions alongside modern urban life. In contrast, Ho Chi Minh City presents a dynamic and energetic atmosphere filled with vibrant markets, cafes, and historical landmarks.",
          "One of Vietnam's most famous attractions is Ha Long Bay, where thousands of limestone islands rise dramatically from emerald waters. Travelers can also explore the picturesque town of Hoi An, known for its lantern-lit streets, riverside charm, and well-preserved architecture.",
          "Food is another highlight of any visit to Vietnam. From steaming bowls of pho to fresh spring rolls and local street food specialties, the country's culinary scene is both diverse and unforgettable.",
        ],
        highlights_title: "Top experiences in Vietnam",
        highlights: [
          "Cruise through the spectacular Ha Long Bay",
          "Wander the historic streets of Hoi An",
          "Discover Hanoi's cultural landmarks",
          "Explore the Mekong Delta",
          "Experience authentic Vietnamese cuisine",
        ],
      },
      {
        anchor: "dubai",
        title: "Dubai: The Ultimate Luxury Destination",
        paragraphs: [
          "Dubai has transformed itself into one of the world's most iconic travel destinations. Renowned for its futuristic skyline, luxury shopping, world-class hospitality, and innovative attractions, Dubai offers an experience unlike anywhere else.",
          "The city's skyline is dominated by the Burj Khalifa, the tallest building in the world, offering panoramic views across the city and desert landscape. Visitors can shop at expansive malls, dine at award-winning restaurants, and enjoy some of the world's most luxurious hotels.",
          "Beyond the modern cityscape, Dubai also offers traditional Arabian experiences. Desert safaris allow travelers to experience dune bashing, camel rides, and cultural performances under the stars. The historic Al Fahidi district provides insight into Dubai's heritage and transformation over the decades.",
        ],
        highlights_title: "Top experiences in Dubai",
        highlights: [
          "Visit the Burj Khalifa observation deck",
          "Enjoy a desert safari adventure",
          "Shop at world-famous malls and souks",
          "Relax at luxury beachfront resorts",
          "Explore Dubai Marina and Palm Jumeirah",
        ],
      },
      {
        anchor: "thailand",
        title: "Thailand: The Land of Smiles",
        paragraphs: [
          "Thailand remains one of Asia's most beloved travel destinations, attracting millions of visitors each year with its welcoming culture, stunning beaches, vibrant cities, and incredible cuisine.",
          "Bangkok, the country's capital, is a lively metropolis where ancient temples stand alongside modern skyscrapers. Visitors can explore the Grand Palace, cruise along the Chao Phraya River, or experience the city's famous street food scene.",
          "For beach lovers, destinations such as Phuket, Krabi, and Koh Samui offer crystal-clear waters, white-sand beaches, and world-class diving opportunities. Meanwhile, northern Thailand, particularly Chiang Mai, provides a more relaxed atmosphere with beautiful mountain scenery, temples, and cultural experiences.",
          "Thailand's affordability, hospitality, and diverse attractions make it an ideal destination for families, couples, solo travelers, and adventure seekers alike.",
        ],
        highlights_title: "Top experiences in Thailand",
        highlights: [
          "Visit the Grand Palace in Bangkok",
          "Relax on the beaches of Phuket and Krabi",
          "Explore Chiang Mai's temples and markets",
          "Experience traditional Thai cuisine",
          "Island-hop through the Andaman Sea",
        ],
      },
      {
        anchor: "which-to-choose",
        title: "Which destination should you choose?",
        paragraphs: [
          "Choosing between Sri Lanka, Vietnam, Dubai, and Thailand ultimately depends on the type of experience you're seeking.",
        ],
        highlights_title: null,
        highlights: [
          "Sri Lanka is perfect for travelers who love nature, wildlife, history, and beaches.",
          "Vietnam offers rich cultural experiences, stunning landscapes, and exceptional food.",
          "Dubai is ideal for luxury travelers seeking world-class entertainment and modern attractions.",
          "Thailand provides an excellent balance of affordability, culture, nightlife, and tropical beauty.",
        ],
      },
    ],
  },
  "europes-timeless-treasures": {
    slug: "europes-timeless-treasures",
    title: "Explore Europe's Timeless Treasures",
    subtitle: "Netherlands, Spain, France & Greece",
    excerpt:
      "Four European countries, four very different reasons to fly — canals and tulips, Mediterranean passion, lavender-soaked countryside, and whitewashed Aegean villages.",
    hero: BLOG_HERO_EUROPE,
    author: "TheCityPair Editorial",
    published_at: "December 2025",
    read_minutes: 10,
    destinations: [
      { anchor: "netherlands", name: "Netherlands", tagline: "Canals, culture & charm",          bg_position: "0% 0%"   },
      { anchor: "spain",       name: "Spain",       tagline: "Passion & Mediterranean beauty",  bg_position: "100% 0%" },
      { anchor: "france",      name: "France",      tagline: "Elegance & world-class experiences", bg_position: "0% 100%" },
      { anchor: "greece",      name: "Greece",      tagline: "Ancient wonders & island paradise", bg_position: "100% 100%" },
    ],
    sections: [
      {
        anchor: "netherlands",
        title: "Netherlands: A Land of Canals, Culture, and Charm",
        paragraphs: [
          "The Netherlands is famous for its picturesque canals, historic cities, colorful tulip fields, and welcoming atmosphere. While Amsterdam often takes center stage, the country offers much more beyond its capital.",
          "Amsterdam's iconic canals, world-renowned museums, and vibrant neighborhoods provide endless opportunities for exploration. Visitors can admire masterpieces at renowned museums, cycle through charming streets, or enjoy a leisurely canal cruise.",
          "Outside the city, travelers can visit the traditional windmills of Kinderdijk, explore the colorful flower fields during spring, and discover charming villages that showcase authentic Dutch culture.",
        ],
        highlights_title: "Top experiences in the Netherlands",
        highlights: [
          "Cruise through Amsterdam's historic canals",
          "Visit the famous tulip gardens during spring",
          "Explore traditional Dutch windmills",
          "Discover the vibrant art and museum scene",
          "Experience cycling culture across the country",
        ],
      },
      {
        anchor: "spain",
        title: "Spain: Passion, Culture, and Mediterranean Beauty",
        paragraphs: [
          "Spain is a country that effortlessly combines centuries of history with modern vibrancy. From bustling cities and architectural masterpieces to sun-soaked beaches and lively festivals, Spain offers an unforgettable travel experience.",
          "Barcelona is known for its remarkable architecture, vibrant atmosphere, and Mediterranean coastline. Madrid, the capital, boasts elegant boulevards, world-class museums, and an energetic nightlife scene.",
          "Further south, Andalusia showcases Spain's Moorish heritage through stunning palaces, historic cities, and flamenco traditions. Along the coast, visitors can enjoy beautiful beaches and charming seaside towns.",
          "Spanish cuisine is another highlight, featuring tapas, seafood specialties, and regional delicacies that reflect the country's diverse cultural influences.",
        ],
        highlights_title: "Top experiences in Spain",
        highlights: [
          "Explore Barcelona's architectural landmarks",
          "Visit Madrid's historic attractions and museums",
          "Experience authentic flamenco performances",
          "Relax on the Costa del Sol beaches",
          "Enjoy traditional Spanish cuisine and tapas",
        ],
      },
      {
        anchor: "france",
        title: "France: Elegance, Romance, and World-Class Experiences",
        paragraphs: [
          "France has long been considered one of the world's most iconic travel destinations. Renowned for its art, culture, gastronomy, and breathtaking landscapes, France offers something for every traveler.",
          "Paris, often called the City of Light, is famous for its historic monuments, elegant boulevards, and romantic ambiance. Visitors can spend days exploring museums, charming neighborhoods, and picturesque cafés.",
          "Beyond Paris, France reveals a remarkable diversity of landscapes. The French Riviera offers glamorous coastal escapes, while Provence enchants visitors with lavender fields and charming villages. Wine enthusiasts can explore renowned vineyard regions, while nature lovers can discover the beauty of the French Alps.",
        ],
        highlights_title: "Top experiences in France",
        highlights: [
          "Visit iconic landmarks in Paris",
          "Explore the French Riviera coastline",
          "Discover Provence's picturesque countryside",
          "Experience world-famous French cuisine",
          "Tour renowned wine-producing regions",
        ],
      },
      {
        anchor: "greece",
        title: "Greece: Ancient Wonders and Island Paradise",
        paragraphs: [
          "Greece is where ancient history meets breathtaking natural beauty. Home to some of the world's most significant archaeological sites, the country also boasts spectacular islands, crystal-clear waters, and a welcoming Mediterranean culture.",
          "Athens serves as the gateway to Greece's rich history, featuring ancient landmarks that have stood for thousands of years. Visitors can explore fascinating ruins while enjoying the city's modern restaurants and vibrant atmosphere.",
          "The Greek islands offer a completely different experience. Santorini captivates travelers with its whitewashed villages and stunning sunsets, while Mykonos is famous for its lively nightlife and beautiful beaches. Crete, Rhodes, and other islands each offer unique cultural and natural attractions.",
          "Greek cuisine, featuring fresh seafood, olive oil, local cheeses, and traditional dishes, is an essential part of every visit.",
        ],
        highlights_title: "Top experiences in Greece",
        highlights: [
          "Explore Athens' ancient archaeological sites",
          "Watch the sunset in Santorini",
          "Relax on the beaches of Mykonos and Crete",
          "Discover traditional Greek villages",
          "Enjoy authentic Mediterranean cuisine",
        ],
      },
      {
        anchor: "which-european",
        title: "Which European destination should you choose?",
        paragraphs: [
          "Whether you're seeking cultural immersion, luxury escapes, historical exploration, or seaside relaxation, these European destinations promise unforgettable memories. Each offers a distinct travel experience:",
        ],
        highlights_title: null,
        highlights: [
          "Netherlands is ideal for culture lovers, cyclists, and those seeking charming cities and scenic landscapes.",
          "Spain appeals to travelers looking for vibrant culture, architecture, beaches, and nightlife.",
          "France offers sophistication, world-class cuisine, iconic landmarks, and diverse regions to explore.",
          "Greece combines ancient history, stunning islands, crystal-clear waters, and Mediterranean charm.",
        ],
      },
    ],
  },
  "escape-to-paradise-pacific": {
    slug: "escape-to-paradise-pacific",
    title: "Escape to Paradise",
    subtitle: "Philippines, Australia, New Zealand & Nadi",
    excerpt:
      "From tropical islands and coral reefs to alpine fjords and cosmopolitan harbours — four Asia-Pacific destinations that promise the trip of a lifetime.",
    hero: BLOG_HERO_PACIFIC,
    author: "TheCityPair Editorial",
    published_at: "December 2025",
    read_minutes: 10,
    destinations: [
      { anchor: "philippines",  name: "Philippines",  tagline: "Over 7,000 islands, endless adventures",  bg_position: "0% 0%"     },
      { anchor: "australia",    name: "Australia",    tagline: "Vibrant cities & natural wonders",        bg_position: "100% 0%"   },
      { anchor: "new-zealand",  name: "New Zealand",  tagline: "Nature's ultimate playground",            bg_position: "0% 100%"   },
      { anchor: "nadi",         name: "Nadi, Fiji",   tagline: "Tropical luxury, island bliss",           bg_position: "100% 100%" },
    ],
    sections: [
      {
        anchor: "philippines",
        title: "Philippines: A Tropical Paradise of Over 7,000 Islands",
        paragraphs: [
          "The Philippines is one of Southeast Asia's most stunning destinations, renowned for its crystal-clear waters, white-sand beaches, and warm hospitality. With more than 7,000 islands, travelers can enjoy endless opportunities for exploration and adventure.",
          "Palawan is often regarded as one of the world's most beautiful islands, featuring dramatic limestone cliffs, hidden lagoons, and pristine beaches. Boracay attracts visitors with its powder-soft white sand and vibrant nightlife, while Cebu offers a blend of history, culture, and incredible marine experiences.",
          "The Philippines is also a paradise for divers and snorkelers, with colorful coral reefs and diverse marine life found throughout the archipelago.",
        ],
        highlights_title: "Top experiences in the Philippines",
        highlights: [
          "Island-hop through Palawan's breathtaking lagoons",
          "Relax on Boracay's famous White Beach",
          "Swim with whale sharks in Cebu",
          "Explore the Chocolate Hills of Bohol",
          "Discover vibrant coral reefs and marine sanctuaries",
        ],
      },
      {
        anchor: "australia",
        title: "Australia: Endless Adventures Down Under",
        paragraphs: [
          "Australia is a land of extraordinary contrasts, where vibrant cities meet rugged outback landscapes, tropical rainforests, and world-famous beaches.",
          "Sydney welcomes visitors with its iconic harbor, stunning coastline, and lively cultural scene. Melbourne is known for its arts, dining, and coffee culture, while Queensland offers access to one of the world's greatest natural wonders, the Great Barrier Reef.",
          "Nature enthusiasts can explore the vast Outback, witness unique wildlife, or drive along some of the world's most scenic coastal routes. Australia's diversity ensures that every journey offers something unique.",
        ],
        highlights_title: "Top experiences in Australia",
        highlights: [
          "Visit Sydney's world-famous harbor",
          "Explore the Great Barrier Reef",
          "Discover Melbourne's cultural attractions",
          "Experience the Australian Outback",
          "Encounter native wildlife including kangaroos and koalas",
        ],
      },
      {
        anchor: "new-zealand",
        title: "New Zealand: Nature's Ultimate Playground",
        paragraphs: [
          "New Zealand is a dream destination for outdoor enthusiasts and nature lovers. Famous for its dramatic landscapes, crystal-clear lakes, towering mountains, and adventure activities, the country consistently ranks among the world's most beautiful travel destinations.",
          "The North Island features geothermal wonders, Maori cultural experiences, and vibrant cities. The South Island showcases breathtaking fjords, alpine scenery, and adventure hubs that attract thrill-seekers from around the world.",
          "Whether you're hiking through national parks, cruising through spectacular fjords, or exploring charming towns, New Zealand delivers unforgettable experiences at every turn.",
        ],
        highlights_title: "Top experiences in New Zealand",
        highlights: [
          "Cruise through Milford Sound",
          "Explore Queenstown, the adventure capital",
          "Visit Rotorua's geothermal attractions",
          "Discover stunning alpine landscapes",
          "Experience authentic Maori culture",
        ],
      },
      {
        anchor: "nadi",
        title: "Nadi, Fiji: Gateway to South Pacific Luxury",
        paragraphs: [
          "Located on Fiji's main island of Viti Levu, Nadi serves as the gateway to one of the South Pacific's most beautiful island nations. Known for its warm hospitality, tropical scenery, and luxurious resorts, Nadi is the perfect destination for travelers seeking relaxation and island adventure.",
          "Visitors can enjoy spectacular beaches, crystal-clear lagoons, and world-class snorkeling opportunities. The nearby Mamanuca and Yasawa Islands offer postcard-perfect tropical escapes featuring turquoise waters and palm-fringed beaches.",
          "Nadi also provides a fascinating cultural experience, blending indigenous Fijian traditions with Indian influences reflected in its cuisine, temples, and local markets.",
        ],
        highlights_title: "Top experiences in Nadi",
        highlights: [
          "Explore the stunning Mamanuca Islands",
          "Relax at luxury beachfront resorts",
          "Enjoy snorkeling and diving adventures",
          "Visit local markets and cultural attractions",
          "Experience traditional Fijian hospitality",
        ],
      },
      {
        anchor: "which-pacific",
        title: "Which destination is right for you?",
        paragraphs: [
          "Each destination offers a unique travel experience. Whether you're dreaming of turquoise waters, breathtaking mountains, vibrant cities, or secluded island retreats, these remarkable destinations create memories that last a lifetime.",
        ],
        highlights_title: null,
        highlights: [
          "Philippines is perfect for beach lovers, island hoppers, and underwater enthusiasts.",
          "Australia combines world-class cities, natural wonders, and unforgettable wildlife encounters.",
          "New Zealand is ideal for adventure seekers and travelers who appreciate spectacular landscapes.",
          "Nadi, Fiji offers tropical luxury, relaxation, and the ultimate island escape.",
        ],
      },
    ],
  },
  "magic-of-mexico-cuba-caribbean": {
    slug: "magic-of-mexico-cuba-caribbean",
    title: "Discover the Magic of Mexico, Cuba & the Caribbean",
    subtitle: "Three tropical worlds, one unforgettable region",
    excerpt:
      "Maya ruins and Pacific resorts, Havana's vintage charm, and the dazzling white-sand islands of the Caribbean — three destinations that define tropical travel.",
    hero: BLOG_HERO_AMERICAS,
    author: "TheCityPair Editorial",
    published_at: "December 2025",
    read_minutes: 9,
    destinations: [
      { anchor: "mexico",    name: "Mexico",        tagline: "Culture, history & coastal beauty", bg_position: "50% 0%"   },
      { anchor: "cuba",      name: "Cuba",          tagline: "Timeless charm & Caribbean spirit", bg_position: "50% 50%"  },
      { anchor: "caribbean", name: "The Caribbean", tagline: "Paradise found in every island",    bg_position: "50% 100%" },
    ],
    sections: [
      {
        anchor: "intro",
        title: "A region built for the trip of a lifetime",
        paragraphs: [
          "Few regions in the world combine vibrant culture, stunning beaches, rich history, and tropical beauty quite like Mexico, Cuba, and the Caribbean. From ancient civilizations and colonial cities to crystal-clear waters and luxury island resorts, these destinations offer unforgettable experiences for travelers seeking adventure, relaxation, and cultural immersion.",
        ],
        highlights_title: null,
        highlights: [],
      },
      {
        anchor: "mexico",
        title: "Mexico: A Land of Culture, History, and Coastal Beauty",
        paragraphs: [
          "Mexico is one of the world's most diverse travel destinations, offering everything from ancient archaeological wonders and colorful colonial cities to luxury beach resorts and world-renowned cuisine.",
          "Visitors can explore the fascinating ruins of the ancient Maya civilization, stroll through charming historic towns, or relax along some of the most beautiful coastlines in North America. Destinations such as Cancun, Riviera Maya, Los Cabos, and Puerto Vallarta attract millions of visitors each year with their pristine beaches and world-class hospitality.",
          "Mexico's culinary heritage is equally impressive. From authentic street tacos and regional specialties to fine dining experiences, food lovers will find endless opportunities to indulge.",
        ],
        highlights_title: "Top experiences in Mexico",
        highlights: [
          "Explore the ancient ruins of Chichen Itza",
          "Relax on the beaches of Cancun and Riviera Maya",
          "Discover the vibrant culture of Mexico City",
          "Experience luxury resorts in Los Cabos",
          "Enjoy authentic Mexican cuisine and local markets",
        ],
      },
      {
        anchor: "cuba",
        title: "Cuba: Timeless Charm and Caribbean Spirit",
        paragraphs: [
          "Cuba offers travelers a unique journey into a world where history, culture, music, and tradition blend seamlessly. Famous for its colorful streets, vintage cars, colonial architecture, and lively atmosphere, Cuba remains one of the Caribbean's most captivating destinations.",
          "Havana, the country's capital, enchants visitors with beautifully preserved architecture, vibrant plazas, and a rich cultural heritage. Travelers can stroll along the iconic Malecón waterfront, enjoy live music performances, and experience the country's legendary hospitality.",
          "Beyond Havana, visitors can explore pristine beaches, tobacco plantations, and charming colonial towns that provide insight into Cuba's fascinating history and culture.",
        ],
        highlights_title: "Top experiences in Cuba",
        highlights: [
          "Explore the historic streets of Havana",
          "Ride in a classic vintage American car",
          "Visit traditional tobacco plantations",
          "Relax on Cuba's beautiful Caribbean beaches",
          "Experience authentic Cuban music and dance",
        ],
      },
      {
        anchor: "caribbean",
        title: "The Caribbean: Paradise Found",
        paragraphs: [
          "The Caribbean is synonymous with turquoise waters, white-sand beaches, luxury resorts, and endless sunshine. Comprising dozens of islands, each destination offers its own unique character and unforgettable experiences.",
          "Travelers can choose from sophisticated luxury destinations, family-friendly beach escapes, adventure-filled islands, or secluded tropical retreats. The region is famous for snorkeling, scuba diving, sailing, and water sports, thanks to its vibrant coral reefs and crystal-clear waters.",
          "Whether visiting Jamaica, the Bahamas, Aruba, Barbados, Saint Lucia, Antigua, or the Dominican Republic, visitors will discover breathtaking scenery and warm island hospitality.",
        ],
        highlights_title: "Top experiences in the Caribbean",
        highlights: [
          "Relax on world-famous white-sand beaches",
          "Snorkel and dive among colorful coral reefs",
          "Explore luxury island resorts",
          "Enjoy Caribbean cuisine and local culture",
          "Experience island-hopping adventures",
        ],
      },
      {
        anchor: "why-travelers-love",
        title: "Why travelers love these destinations",
        paragraphs: [
          "What makes Mexico, Cuba, and the Caribbean so appealing is their ability to offer something for every traveler. Whether you're planning a romantic getaway, family vacation, luxury retreat, or cultural adventure, these destinations deliver unforgettable experiences that will leave you dreaming of your next journey long after you return home.",
        ],
        highlights_title: null,
        highlights: [
          "Mexico delivers a perfect combination of history, culture, luxury, and adventure.",
          "Cuba offers authentic cultural experiences unlike anywhere else in the Caribbean.",
          "The Caribbean provides the ultimate tropical escape with stunning beaches and luxury island living.",
        ],
      },
      {
        anchor: "perfect-escape",
        title: "The perfect tropical escape awaits",
        paragraphs: [
          "From the ancient wonders of Mexico and the timeless charm of Cuba to the idyllic islands of the Caribbean, these remarkable destinations showcase the very best of tropical travel. Pack your bags, embrace the sunshine, and discover why millions of travelers return to these extraordinary destinations year after year.",
        ],
        highlights_title: null,
        highlights: [],
      },
    ],
  },
  "wonders-of-scandinavia": {
    slug: "wonders-of-scandinavia",
    title: "Discover the Wonders of Scandinavia",
    subtitle: "Norway, Iceland, Finland & Sweden",
    excerpt:
      "Fjords, fire-and-ice landscapes, glass igloos under the aurora, and design-forward Nordic capitals — four destinations that define adventure at the top of the world.",
    hero: BLOG_HERO_NORDIC,
    author: "TheCityPair Editorial",
    published_at: "December 2025",
    read_minutes: 10,
    destinations: [
      { anchor: "norway",  name: "Norway",  tagline: "Fjords & Arctic wonders",          bg_position: "0% 0%"     },
      { anchor: "iceland", name: "Iceland", tagline: "Fire, ice & geothermal magic",     bg_position: "100% 0%"   },
      { anchor: "finland", name: "Finland", tagline: "Glass igloos & Lapland nights",    bg_position: "0% 100%"   },
      { anchor: "sweden",  name: "Sweden",  tagline: "Stockholm style & wild archipelagos", bg_position: "100% 100%" },
    ],
    sections: [
      {
        anchor: "intro",
        title: "The Nordic region, at a glance",
        paragraphs: [
          "Scandinavia and the Nordic region are home to some of the world's most breathtaking landscapes, vibrant cities, and unique cultural experiences. From Norway's majestic fjords and Iceland's volcanic wonders to Finland's magical Arctic experiences and Sweden's sophisticated cities, these destinations offer unforgettable journeys for travelers seeking adventure, natural beauty, and authentic Nordic charm.",
        ],
        highlights_title: null,
        highlights: [],
      },
      {
        anchor: "norway",
        title: "Norway: Land of Spectacular Fjords and Natural Wonders",
        paragraphs: [
          "Norway is renowned for its dramatic landscapes, towering mountains, deep fjords, and picturesque coastal villages. It is a destination that captivates nature lovers and adventure seekers alike.",
          "Visitors can cruise through world-famous fjords surrounded by towering cliffs and cascading waterfalls. The country's scenic railways and coastal routes offer some of the most stunning views in Europe.",
          "Norway is also one of the best places in the world to witness the magical Northern Lights during the winter months, while the summer season offers the extraordinary experience of the Midnight Sun.",
        ],
        highlights_title: "Top experiences in Norway",
        highlights: [
          "Cruise through the magnificent Norwegian fjords",
          "Chase the Northern Lights in Arctic Norway",
          "Ride the scenic Flåm Railway",
          "Explore the vibrant city of Oslo",
          "Experience the Midnight Sun above the Arctic Circle",
        ],
      },
      {
        anchor: "iceland",
        title: "Iceland: The Land of Fire and Ice",
        paragraphs: [
          "Iceland is unlike anywhere else on Earth. Known for its volcanoes, glaciers, waterfalls, black-sand beaches, and geothermal wonders, the country offers extraordinary natural experiences at every turn.",
          "The famous Golden Circle route showcases some of Iceland's most iconic attractions, including geysers, waterfalls, and tectonic landscapes. Visitors can also relax in geothermal lagoons, hike across glaciers, and explore volcanic terrain.",
          "Iceland's pristine environment and dramatic scenery have made it one of the world's most sought-after adventure destinations.",
        ],
        highlights_title: "Top experiences in Iceland",
        highlights: [
          "Explore the Golden Circle",
          "Relax in geothermal hot springs",
          "Visit spectacular waterfalls and glaciers",
          "Witness the Northern Lights",
          "Discover black-sand beaches and volcanic landscapes",
        ],
      },
      {
        anchor: "finland",
        title: "Finland: Arctic Adventures and Nordic Serenity",
        paragraphs: [
          "Finland offers travelers a unique blend of modern design, pristine wilderness, and Arctic experiences. Known as the happiest country in the world, Finland combines natural beauty with a high quality of life and warm hospitality.",
          "During winter, Finnish Lapland transforms into a snowy wonderland where visitors can meet reindeer, ride husky sleds, and stay in glass igloos beneath the Northern Lights.",
          "In summer, Finland's thousands of lakes and forests provide endless opportunities for hiking, boating, and outdoor recreation. Helsinki, the country's capital, offers world-class architecture, design, and culinary experiences.",
        ],
        highlights_title: "Top experiences in Finland",
        highlights: [
          "Stay in a glass igloo under the Northern Lights",
          "Experience Finnish Lapland",
          "Enjoy traditional Finnish saunas",
          "Explore Helsinki's modern design scene",
          "Discover the country's lakes and forests",
        ],
      },
      {
        anchor: "sweden",
        title: "Sweden: Innovation, Culture, and Natural Beauty",
        paragraphs: [
          "Sweden perfectly balances modern sophistication with stunning natural landscapes. From cosmopolitan cities to untouched wilderness, Sweden offers a diverse range of experiences for every traveler.",
          "Stockholm, often referred to as the \"Venice of the North,\" is built across a collection of islands connected by scenic bridges. The city combines historic charm with contemporary culture, exceptional dining, and world-class museums.",
          "Beyond the cities, Sweden offers vast forests, picturesque lakes, and opportunities to experience the Northern Lights in the northern regions. Visitors can also enjoy Sweden's famous commitment to sustainability and outdoor living.",
        ],
        highlights_title: "Top experiences in Sweden",
        highlights: [
          "Explore Stockholm's historic old town",
          "Visit world-class museums and cultural attractions",
          "Discover Sweden's beautiful archipelagos",
          "Experience the Northern Lights in Swedish Lapland",
          "Enjoy outdoor adventures in pristine natural settings",
        ],
      },
      {
        anchor: "why-nordic",
        title: "Why visit Scandinavia and the Nordic region?",
        paragraphs: [
          "These destinations offer some of the most extraordinary travel experiences in the world:",
        ],
        highlights_title: null,
        highlights: [
          "Norway is perfect for fjords, mountain landscapes, and Arctic adventures.",
          "Iceland offers unmatched geological wonders and dramatic scenery.",
          "Finland provides magical winter experiences and peaceful natural escapes.",
          "Sweden combines sophisticated cities with breathtaking nature.",
        ],
      },
      {
        anchor: "ultimate-adventure",
        title: "The ultimate Nordic adventure",
        paragraphs: [
          "Whether you're seeking the Northern Lights, dramatic fjords, geothermal wonders, Arctic adventures, or stylish Scandinavian cities, Norway, Iceland, Finland, and Sweden deliver unforgettable experiences throughout every season. These destinations showcase some of the planet's most spectacular landscapes and offer travelers the opportunity to experience nature at its most magnificent.",
          "From snow-covered Arctic adventures to vibrant summer landscapes illuminated by the Midnight Sun, Scandinavia promises memories that will last a lifetime.",
        ],
        highlights_title: null,
        highlights: [],
      },
    ],
  },
  "best-of-the-united-kingdom": {
    slug: "best-of-the-united-kingdom",
    title: "Discover the Best of the United Kingdom",
    subtitle: "London, Scotland, Northern Ireland & Wales",
    excerpt:
      "London's royal heritage, the Highlands of Scotland, Northern Ireland's legendary coastline, and the castles and mountains of Wales — four nations, one unforgettable journey.",
    hero: BLOG_HERO_UK,
    author: "TheCityPair Editorial",
    published_at: "December 2025",
    read_minutes: 10,
    destinations: [
      { anchor: "london",            name: "London",            tagline: "Culture, royal heritage & luxury",      bg_position: "0% 0%"     },
      { anchor: "scotland",          name: "Scotland",          tagline: "Highlands, castles & whisky",            bg_position: "100% 0%"   },
      { anchor: "northern-ireland",  name: "Northern Ireland",  tagline: "Coastal drama & legendary landscapes",   bg_position: "0% 100%"   },
      { anchor: "wales",             name: "Wales",             tagline: "Mountains, castles & coastal beauty",    bg_position: "100% 100%" },
    ],
    sections: [
      {
        anchor: "intro",
        title: "Four nations, one extraordinary destination",
        paragraphs: [
          "The United Kingdom is a destination where centuries of history blend seamlessly with modern culture, breathtaking landscapes, and world-class hospitality. From the iconic landmarks of London and the dramatic Highlands of Scotland to the rugged coastlines of Northern Ireland and the picturesque countryside of Wales, the UK offers an extraordinary variety of experiences for every traveler.",
        ],
        highlights_title: null,
        highlights: [],
      },
      {
        anchor: "london",
        title: "London: A Global City of History, Culture, and Luxury",
        paragraphs: [
          "London is one of the world's most exciting cities, offering a perfect mix of royal heritage, iconic landmarks, luxury shopping, and cultural attractions. As the capital of the United Kingdom, London welcomes millions of visitors each year with its vibrant energy and timeless appeal.",
          "Travelers can explore famous landmarks such as Buckingham Palace, the Tower of London, and Big Ben, while enjoying world-class museums, theatres, and restaurants. The city's diverse neighborhoods offer everything from luxury boutiques and historic pubs to trendy markets and fine dining experiences.",
          "Whether you're interested in history, art, fashion, or entertainment, London delivers unforgettable experiences at every turn.",
        ],
        highlights_title: "Top experiences in London",
        highlights: [
          "Visit Buckingham Palace and witness the Changing of the Guard",
          "Explore the historic Tower of London",
          "Enjoy panoramic views from the London Eye",
          "Shop in Mayfair, Knightsbridge, and Oxford Street",
          "Experience London's famous West End theatre district",
        ],
      },
      {
        anchor: "scotland",
        title: "Scotland: Majestic Highlands and Timeless Heritage",
        paragraphs: [
          "Scotland captivates visitors with its dramatic landscapes, ancient castles, rich history, and warm hospitality. From the bustling streets of Edinburgh to the breathtaking beauty of the Highlands, Scotland offers a truly unique travel experience.",
          "Edinburgh, Scotland's capital, is renowned for its medieval Old Town, historic castle, and vibrant festivals. Beyond the cities, travelers can discover scenic lochs, rugged mountains, and charming villages that showcase the country's natural beauty.",
          "Scotland is also famous for its whisky heritage, making distillery tours a popular experience for visitors seeking a taste of local culture.",
        ],
        highlights_title: "Top experiences in Scotland",
        highlights: [
          "Explore Edinburgh Castle and the Royal Mile",
          "Visit the breathtaking Scottish Highlands",
          "Discover the mystery of Loch Ness",
          "Tour world-famous whisky distilleries",
          "Experience Scotland's rich cultural traditions",
        ],
      },
      {
        anchor: "northern-ireland",
        title: "Northern Ireland: Stunning Coastlines and Legendary Landscapes",
        paragraphs: [
          "Northern Ireland is one of the UK's hidden gems, offering dramatic coastal scenery, fascinating history, and vibrant cities. The region has gained international attention for its spectacular natural beauty and iconic filming locations.",
          "Belfast, the capital city, combines industrial heritage with modern attractions, including museums, waterfront developments, and lively cultural districts. Along the coast, travelers can visit the world-famous Giant's Causeway, a natural wonder featuring unique basalt rock formations.",
          "Northern Ireland's scenic drives, historic castles, and charming villages make it an excellent destination for road-trip enthusiasts and nature lovers.",
        ],
        highlights_title: "Top experiences in Northern Ireland",
        highlights: [
          "Visit the iconic Giant's Causeway",
          "Explore Belfast's rich maritime history",
          "Drive along the stunning Causeway Coastal Route",
          "Discover historic castles and estates",
          "Experience local Irish hospitality and culture",
        ],
      },
      {
        anchor: "wales",
        title: "Wales: Castles, Mountains, and Coastal Beauty",
        paragraphs: [
          "Wales offers a captivating blend of rugged landscapes, medieval castles, and charming towns. Despite its compact size, the country boasts some of the most spectacular scenery in the United Kingdom.",
          "Snowdonia National Park attracts outdoor enthusiasts with its mountains, hiking trails, and breathtaking views. Along the coast, visitors can discover beautiful beaches, picturesque fishing villages, and dramatic cliffs.",
          "Wales is also known as the \"Land of Castles,\" with hundreds of historic fortresses scattered across the country, providing a fascinating glimpse into its rich history.",
        ],
        highlights_title: "Top experiences in Wales",
        highlights: [
          "Explore Snowdonia National Park",
          "Visit medieval castles throughout the country",
          "Discover the stunning Pembrokeshire coastline",
          "Experience traditional Welsh culture and cuisine",
          "Enjoy outdoor adventures and scenic railway journeys",
        ],
      },
      {
        anchor: "why-uk",
        title: "Why visit the United Kingdom?",
        paragraphs: [
          "Each region offers a distinct experience:",
        ],
        highlights_title: null,
        highlights: [
          "London provides world-class culture, luxury, and iconic attractions.",
          "Scotland offers dramatic landscapes, castles, and rich heritage.",
          "Northern Ireland showcases spectacular coastlines and natural wonders.",
          "Wales combines stunning scenery, historic castles, and outdoor adventure.",
        ],
      },
      {
        anchor: "british-adventure",
        title: "Your ultimate British adventure awaits",
        paragraphs: [
          "Whether you're strolling through London's historic streets, exploring Scotland's majestic Highlands, admiring Northern Ireland's dramatic coastline, or discovering Wales' medieval castles, the United Kingdom promises unforgettable experiences for every traveler.",
          "From luxury city escapes and cultural discoveries to scenic road trips and outdoor adventures, these remarkable destinations showcase the very best of British travel and continue to inspire visitors from around the world year after year.",
        ],
        highlights_title: null,
        highlights: [],
      },
    ],
  },
};

export function listBlogTeasers() {
  return Object.values(BLOG_POSTS).map((p) => ({
    slug: p.slug,
    title: p.title,
    subtitle: p.subtitle,
    excerpt: p.excerpt,
    hero: p.hero,
    read_minutes: p.read_minutes,
    published_at: p.published_at,
    destinations: p.destinations,
  }));
}

/**
 * Primary airport for each blog destination, keyed by section anchor.
 * Used by inline "Search flights to X" CTAs inside blog posts.
 */
export const DESTINATION_AIRPORT = {
  // Asia
  "sri-lanka":        { code: "CMB", city: "Colombo" },
  "vietnam":          { code: "SGN", city: "Ho Chi Minh City" },
  "dubai":            { code: "DXB", city: "Dubai" },
  "thailand":         { code: "BKK", city: "Bangkok" },
  // Europe
  "netherlands":      { code: "AMS", city: "Amsterdam" },
  "spain":            { code: "MAD", city: "Madrid" },
  "france":           { code: "CDG", city: "Paris" },
  "greece":           { code: "ATH", city: "Athens" },
  // Pacific
  "philippines":      { code: "MNL", city: "Manila" },
  "australia":        { code: "SYD", city: "Sydney" },
  "new-zealand":      { code: "AKL", city: "Auckland" },
  "nadi":             { code: "NAN", city: "Nadi" },
  // Americas
  "mexico":           { code: "CUN", city: "Cancun" },
  "cuba":             { code: "HAV", city: "Havana" },
  "caribbean":        { code: "MBJ", city: "Montego Bay" },
  // Nordic
  "norway":           { code: "OSL", city: "Oslo" },
  "iceland":          { code: "KEF", city: "Reykjavik" },
  "finland":          { code: "HEL", city: "Helsinki" },
  "sweden":           { code: "ARN", city: "Stockholm" },
  // UK
  "london":           { code: "LHR", city: "London" },
  "scotland":         { code: "EDI", city: "Edinburgh" },
  "northern-ireland": { code: "BFS", city: "Belfast" },
  "wales":            { code: "CWL", city: "Cardiff" },
};

/**
 * Build a deep-link to the search-results page pre-populated for a destination.
 * Defaults: JFK origin, 21 days out, 7-day round trip, 1 pax economy.
 * The user lands directly on results and can change origin/dates inline.
 */
export function buildFlightSearchUrl(anchor, { originCode = "JFK" } = {}) {
  const dest = DESTINATION_AIRPORT[anchor];
  if (!dest) return "/";
  const fmt = (d) => d.toISOString().slice(0, 10);
  const depart = new Date(Date.now() + 21 * 86400000);
  const ret    = new Date(Date.now() + 28 * 86400000);
  const params = new URLSearchParams({
    trip_type: "round_trip",
    origin: originCode,
    destination: dest.code,
    depart_date: fmt(depart),
    return_date: fmt(ret),
    passengers: "1",
    cabin: "economy",
  });
  return `/search?${params.toString()}`;
}
